import { useMutation, useQueryClient } from '@tanstack/react-query'
import * as orgsAPI from '@/api/orgsAPI'
import type { UUID } from 'crypto'

export function useGenerateProfile() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ token, orgUuid }: { token: string; orgUuid: UUID }) =>
      orgsAPI.generateProfile(token, orgUuid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['currentOrgs'] })
    },
  })
}
